export default __webpack_public_path__ + "static/media/Blade's Mask of the Battlethrall.fdef6016.jpg";